<div class="hub-similar-calendar">

    <div *ngIf="!isNoContent" class="similar-tips">
        <mat-icon>help_outline</mat-icon>
        <div *ngIf="selectedTabIndex===0">
            <p *ngIf="type === 'ai'" style="color: deepskyblue">These events are considered as similar by AI</p>
            <p>Events in the same row are considered similar</p>
            <p *ngIf="type !== 'ai'">Similar info is marked with the same underline color</p>
        </div>
        <div *ngIf="selectedTabIndex===1">
            <p>Events in the same row are considered a multi-dates event</p>
            <!--            <p>Similar info is marked with the same underline color</p>-->
        </div>

        <!-- <div style="position: absolute; right: 20px; top: 20px; display: flex; gap: 24px">
            <div style="cursor: pointer; text-decoration: underline; color: deepskyblue"
                (click)="type='normal';getSimilarEvents()">Normal</div>
            <div style="cursor: pointer; text-decoration: underline; color: deepskyblue"
                (click)="type='ai';getSimilarEvents()">AI</div>
        </div> -->
    </div>

    <mat-tab-group (selectedTabChange)="tabChange($event)">
        <mat-tab>
            <ng-template mat-tab-label>
                Similar Events
            </ng-template>
            <div class="m-t-3">
                <div *ngFor="let groupWithCondition of similarEventsByExactSame" class="similar-row">
                    <div *ngFor="let event of groupWithCondition.group;let i = index;" class="similar-card">
                        <div class="approved e-status" *ngIf="event.isApproved">approved</div>
                        <div class="unapproved e-status" *ngIf="!event.isApproved">pending approval</div>
                        <div class="in-custom-btn e-status" *ngIf="isInCustomBtn(event)">in custom btn</div>

                        <div class="operation">
                            <ig-card-action *ngIf="!event.isApproved" icon="done" matTooltip="Approve"
                                matTooltipPosition="right" (click)="approve(event)">
                            </ig-card-action>
                            <ig-card-action *ngIf="event.isApproved" icon="clear" matTooltip="Unapprove"
                                matTooltipPosition="right" (click)="unApprove(event)">
                            </ig-card-action>
                            <ig-card-action icon="edit" matTooltip="Edit" matTooltipPosition="right"
                                (click)="showEditModal(event)">
                            </ig-card-action>
                            <ig-card-action icon="delete_forever"
                                matTooltip="Remove this event to your remove list,events that are removed can be reverted as needed."
                                matTooltipPosition="right" (click)="block(event)">
                            </ig-card-action>

                            <ig-drop-down [class.position-initial]="
                            customBtns &&
                            customBtns.events &&
                            customBtns.events.length > 4
                          " [class.lower-top]="
                          customBtns.events &&
                          customBtns.events.length > 4 &&
                          customBtns.events.length < 9
                          " showDropDownItem="true" class="long-btn">
                                <ig-drop-down-trigger [useDiv]="true" class="add-to-tour" icon="star"
                                    matTooltip="Add to custom button" matTooltipClass="card-tooltip"
                                    matTooltipPosition="right">
                                </ig-drop-down-trigger>
                                <div items>
                                    <ng-container *ngFor="let btn of customBtns.events; let i = index">
                                        <ig-drop-down-item *ngIf="btn.sourceType === 'selected'"
                                            (click)="addOrRemoveToCustomBtn(event,btn, i)"
                                            matTooltip="{{ btn.btnText }}">
                                            <mat-icon class="red" *ngIf="isInCustomBtn(event,btn)">remove</mat-icon>
                                            <mat-icon *ngIf="!isInCustomBtn(event,btn)">add</mat-icon>
                                            {{ btn.btnText }}
                                        </ig-drop-down-item>
                                    </ng-container>
                                    <ig-drop-down-item *ngIf="!customBtns.events || !customBtns.events.length"
                                        (click)="gotoTours()" matTooltip="Go to add a custom button"
                                        matTooltipClass="card-tooltip">(no
                                        custom buttons available, create one)
                                    </ig-drop-down-item>
                                </div>
                            </ig-drop-down>

                        </div>

                        <ig-image [imageUrl]="event.cover?.source"></ig-image>
                        <p><b [class.similar-name]="isSimilarField('name', event._id, groupWithCondition.condition)">{{
                                event.name }}</b>
                        </p>
                        <p>@&nbsp;<span
                                [class.similar-owner]="isSimilarField('owner', event._id, groupWithCondition.condition)">{{
                                event.owner.name }}</span>
                        </p>
                        <p
                            [class.similar-start-time]="isSimilarField('startTime', event._id, groupWithCondition.condition)">
                            <mat-icon>schedule</mat-icon>
                            {{matchedTime(groupWithCondition.condition, i)}}
                            <mat-icon *ngIf="event.startTimeFormatted !== matchedTime(groupWithCondition.condition, i)"
                                matTooltip="This is one of the dates from a multi-day event">info</mat-icon>
                        </p>
                        <p [class.similar-address]="isSimilarField('address', event._id, groupWithCondition.condition)">
                            <mat-icon>room</mat-icon>
                            {{ componentAddress(event) }}
                        </p>
                    </div>
                </div>

                <ig-no-content *ngIf="isNoContent"></ig-no-content>
            </div>
        </mat-tab>

        <!--        <mat-tab>-->
        <!--            <ng-template mat-tab-label>-->
        <!--                Multi-dates Events-->
        <!--            </ng-template>-->
        <!--            <div class="m-t-3">-->
        <!--                <div *ngFor="let groupWithCondition of similarMultiDatesEvents" class="similar-row">-->
        <!--                    <div *ngFor="let event of groupWithCondition.group" class="similar-card">-->
        <!--                        <div class="approved e-status" *ngIf="event.isApproved">approved</div>-->
        <!--                        <div class="unapproved e-status" *ngIf="!event.isApproved">pending approval</div>-->
        <!--                        <div class="in-custom-btn e-status" *ngIf="isInCustomBtn(event)">in custom btn</div>-->

        <!--                        <div class="operation">-->
        <!--                            <ig-card-action *ngIf="!event.isApproved" icon="done" matTooltip="Approve"-->
        <!--                                            matTooltipPosition="right" (click)="approve(event)">-->
        <!--                            </ig-card-action>-->
        <!--                            <ig-card-action *ngIf="event.isApproved" icon="clear" matTooltip="Unapprove"-->
        <!--                                            matTooltipPosition="right" (click)="unApprove(event)">-->
        <!--                            </ig-card-action>-->
        <!--                            <ig-card-action icon="edit" matTooltip="Edit" matTooltipPosition="right"-->
        <!--                                            (click)="showEditModal(event)">-->
        <!--                            </ig-card-action>-->
        <!--                            <ig-card-action icon="delete_forever"-->
        <!--                                            matTooltip="Remove this event to your remove list,events that are removed can be reverted as needed."-->
        <!--                                            matTooltipPosition="right" (click)="block(event)">-->
        <!--                            </ig-card-action>-->
        <!--                            <ig-drop-down [class.position-initial]="-->
        <!--                            customBtns &&-->
        <!--                            customBtns.events &&-->
        <!--                            customBtns.events.length > 4-->
        <!--                          " [class.lower-top]="-->
        <!--                          customBtns.events &&-->
        <!--                          customBtns.events.length > 4 &&-->
        <!--                          customBtns.events.length < 9-->
        <!--                          " showDropDownItem="true" class="long-btn">-->
        <!--                                <ig-drop-down-trigger [useDiv]="true" class="add-to-tour" icon="star"-->
        <!--                                                      matTooltip="Add to custom button" matTooltipClass="card-tooltip"-->
        <!--                                                      matTooltipPosition="right">-->
        <!--                                </ig-drop-down-trigger>-->
        <!--                                <div items>-->
        <!--                                    <ng-container *ngFor="let btn of customBtns.events; let i = index">-->
        <!--                                        <ig-drop-down-item *ngIf="btn.sourceType === 'selected'"-->
        <!--                                                           (click)="addOrRemoveToCustomBtn(event,btn, i)"-->
        <!--                                                           matTooltip="{{ btn.btnText }}">-->
        <!--                                            <mat-icon class="red" *ngIf="isInCustomBtn(event,btn)">remove</mat-icon>-->
        <!--                                            <mat-icon *ngIf="!isInCustomBtn(event,btn)">add</mat-icon>-->
        <!--                                            {{ btn.btnText }}-->
        <!--                                        </ig-drop-down-item>-->
        <!--                                    </ng-container>-->
        <!--                                    <ig-drop-down-item *ngIf="!customBtns.events || !customBtns.events.length">(no-->
        <!--                                        custom buttons available)-->
        <!--                                    </ig-drop-down-item>-->
        <!--                                </div>-->
        <!--                            </ig-drop-down>-->
        <!--                        </div>-->

        <!--                        <ig-image [imageUrl]="event.cover?.source"></ig-image>-->
        <!--                        <p><b>{{ event.name }}</b></p>-->
        <!--                        <p>@&nbsp;<span>{{ event.owner.name }}</span></p>-->
        <!--                        <p class="similar-start-time">-->
        <!--                            <mat-icon>schedule</mat-icon>-->
        <!--                            {{ event.startTimeFormatted }}-->
        <!--                        </p>-->
        <!--                        <p *ngIf="event.address?.address">-->
        <!--                            <mat-icon>room</mat-icon>-->
        <!--                            {{ event.address.address }}-->
        <!--                        </p>-->
        <!--                    </div>-->
        <!--                </div>-->

        <!--                <ig-no-content *ngIf="isNoContentForMultiDatesEvents"></ig-no-content>-->
        <!--            </div>-->
        <!--        </mat-tab>-->

    </mat-tab-group>
    <ng-container>
        <ig-page-spinner #spinner></ig-page-spinner>
    </ng-container>

</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/similar.calendar/hub.similar.calendar.component.html